import React from 'react';
import { PartnerLedgerBlocks } from '../components/integration/PartnerLedgerPages';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

function KAISTMyBlocks({ user }: { user: UserInfo }) {
  return <PartnerLedgerBlocks partner="KAIST" user={user} />;
}

export default React.memo(KAISTMyBlocks);
